import { Box, Button, Modal, Skeleton, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import PropertySearch from "../../components/property-search";
import { Link } from "react-router-dom";
import { PropertyCard } from "../home";
import { COLORS } from "../../utils/colors";

export const CompareProperty = ({ property = {} }) => {
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [open, setOpen] = useState(false);

  const handlePropertySearch = (properties) => {
    setProperties(properties);
  };

  const handlePropertyToCompareSelect = (property) => () => {
    setOpen(false);
    setSelectedProperties((selectedProperties) => [
      ...selectedProperties,
      property,
    ]);
  };

  const handlePropertyFromSearch = (property) => {
    setOpen(false);
    setSelectedProperties((selectedProperties) => [
      ...selectedProperties,
      property,
    ]);
  };

  const AdditionalDetails = (property) => {
    const { onMarket, pool = false, squareFeet, yearBuilt } = property;
    return (
      <Fragment>
        <Box>
          <Typography variant="caption" sx={{ color: "#000" }}>
            Area:{" "}
          </Typography>
          <Typography variant="caption" fontWeight={800} ml={1}>
            {squareFeet ? `${squareFeet}sqft` : "N/A"}
          </Typography>
        </Box>
      </Fragment>
    );
  };

  return (
    <Box sx={{ maxWidth: "100%", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          width: "100%",
        }}
      >
        <Button
          onClick={() => setOpen(true)}
          style={{
            backgroundColor: COLORS.SURFACE_1,
            color: "#fff",
            textTransform: "none",
          }}
        >
          {selectedProperties && selectedProperties.length > 0
            ? "Add more properties"
            : "Compare this property"}
        </Button>
        {selectedProperties && selectedProperties.length > 0 && (
          <Button
            style={{ color: COLORS.SURFACE_1, textTransform: "none" }}
            onClick={() => setSelectedProperties([])}
          >
            Clear
          </Button>
        )}
      </Box>
      {selectedProperties && selectedProperties.length ? (
        <Box
          sx={{
            alignItems: "flex-end",
            backgroundColor: "rgba(0, 0, 0, 0.02)",
            borderRadius: 2,
            display: "flex",
            justifyContent: "flex-start",
            gap: 2,
            overflowX: "auto",
            maxWidth: "100%",
            position: "relative",
            padding: "20px",
            paddingRight: "calc(100% - 430px)",
          }}
        >
          <Box
            sx={{
              position: "sticky",
              "& *": {
                color: COLORS.SURFACE_1,
              },
            }}
          >
            <PropertyCard
              additionalDetailsRenderer={AdditionalDetails}
              backgroundColor={COLORS.SURFACE_2}
              property={{ ...property, photoUrl: property?.photoUrls?.[0] }}
              showPrices={true}
              width={200}
            />
          </Box>
          {selectedProperties.map((property) => {
            const { id } = property;

            return (
              <Box key={id}>
                <Link to={`/property/${id}`} target="_blank">
                  <PropertyCard
                    redirectOnClick={false}
                    additionalDetailsRenderer={AdditionalDetails}
                    property={property}
                    showPrices={true}
                    showImageModalOnClick={true}
                    width={200}
                  />
                </Link>
              </Box>
            );
          })}
        </Box>
      ) : null}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            left: "50%",
            position: "fixed",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              height: "80vh",
              overflow: "auto",
              width: "80vw",
            }}
          >
            <Typography
              style={{ marginBottom: 20, textAlign: "center", padding: 20 }}
              variant="h6"
            >
              SEARCH PROPERTY TO COMPARE
            </Typography>
            <PropertySearch
              onChange={handlePropertySearch}
              onPropertySelectFromSearch={handlePropertyFromSearch}
              setIsLoadingProperties={setIsLoading}
            />

            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 2,
                  marginTop: 2,
                }}
              >
                {[...Array(3)].map((_, index) => (
                  <Box height={300} key={index} width={345}>
                    <Skeleton
                      animation="wave"
                      height={300}
                      key={index}
                      width={345}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 2,
                  marginTop: 2,
                }}
              >
                {properties.map((property) => {
                  return (
                    <Button onClick={handlePropertyToCompareSelect(property)}>
                      <PropertyCard
                        redirectOnClick={false}
                        property={property}
                        key={property.id}
                      />
                    </Button>
                  );
                })}
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
